define([
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/locale",
	"csi/sessionConstants",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton"
], function(lang,def,Action,locale,sessionConstants,PluginFactory,ToolbarPluginButton) {

	return PluginFactory.declare("tableExpand", ToolbarPluginButton, {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_accessAction: lang.hitch(this, this._onAccessAction),
				m_class: "iconExpanded",
				m_id: "TableExpand",
				m_typeControl: def.ACTION_ICON
			});
			this.defAction.resolve();

			const max = sessionConstants.maxResultSize;
			if (max) {
				this.defAction.m_tooltip += locale.resource("TableDisabledByLimit", [max]);
			}
		},

		canShowPlugin: function() {
			// summary: hide if view is not hierarchical
			return this.getView().bHierarchy;
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: only available if table has relationship
			return !!ctx.view.relRoot;
		},

		_onAccessAction: function(/*Context*/ctx, /*Action*/action) {
			// summary: check if the table has hierarchy, and disable if number of results exceeds max result size limit
			return ctx.view.getLevelToExpand(true) != null;
		}
	});
});